import React, { useState } from 'react'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import toast from 'react-hot-toast';

const PaymentMethod = ({ balanceAmount, payments, setPayments, setModal }) => {
    const [form, setForm] = useState({});

    const methods = [
        { option: 'Bank Transfer', value: "BANK" },
        { option: 'Cheque', value: "CHEQUE" },
        { option: 'Cash', value: "CASH" },
        { option: 'Wallet / Compliment', value: "WALLET" }
    ]

    const handleChange = (e) => {
        // Method
        if (e.target.name === 'method') {
            setForm({
                [e.target.name]: e.target.value,
                amount: balanceAmount
            })
            return;
        }

        // Amount
        if (e.target.name === 'amount') {
            if (!/^\d*\.?\d{0,2}$/.test(e.target.value)) return;
            if (Number(e.target.value) > balanceAmount) return;

            setForm({ ...form, [e.target.name]: e.target.value })
            return;
        }

        // Other
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleAddMethod = (e) => {
        e.preventDefault();

        // check the method already selected
        if (payments?.find(p => p?.method === form?.method)) {
            toast.error('Method already selected')
            return;
        }

        setPayments((state) => [
            ...state,
            {
                unique_id: new Date().getTime(),
                method: form?.method,
                amount: form?.amount,
                txn_id: form?.txn_id ?? null,
                cheque_no: form?.cheque_no ?? null,
                bank_name: form?.bank_name ?? null,
                cheque_date: form?.cheque_date ?? null,
                wallet_id: form?.wallet_id ?? null
            }
        ])

        setModal({ status: false })
    }

    return (
        <div>
            <form action="" onSubmit={handleAddMethod}>
                <SelectInput label='Method *' name='method' onChangeFun={handleChange}
                    values={methods} firstOption={{ option: 'Choose...', value: '' }} />

                <NormalInput label='Amount *' type={'number'} name='amount' value={form?.amount || ''} onChangeFun={handleChange}
                    inputMode='decimal' step="any" onKeyDown={(e) => {
                        if (['-', '+', 'e', 'E'].includes(e.key)) {
                            e.preventDefault();
                        }
                    }} />

                {/* Bank */}
                {form?.method === 'BANK' && (
                    <NormalInput label='Transaction ID *' type={'text'} name='txn_id' value={form?.txn_id || ''} onChangeFun={handleChange} />
                )}

                {/* Cheque */}
                {form?.method === 'CHEQUE' && <>
                    <NormalInput label='Check No *' type={'text'} name='cheque_no' value={form?.cheque_no || ''} onChangeFun={handleChange} />
                    <NormalInput label='Bank Name *' type={'text'} name='bank_name' value={form?.bank_name || ''} onChangeFun={handleChange} />
                    <NormalInput label='Cheque Date *' type={'date'} name='cheque_date' value={form?.cheque_date || ''} onChangeFun={handleChange} />
                </>}

                {/* Wallet */}
                {form?.method === 'WALLET' && (
                    <NormalInput label='Wallet Id / Customer Id *' type={'text'} name='wallet_id' value={form?.wallet_id || ''} onChangeFun={handleChange} />
                )}

                <button className='method-button' type='submit'>Pay now</button>
            </form>
        </div>
    )
}

export default PaymentMethod